import { Component, EventEmitter, Input, Output, Renderer2, ViewChild, ElementRef } from '@angular/core';
import * as QRCode from 'qrcode';
import { ModalService } from '../../dialogs/modal/modal.service';
import { CoreLibLinkConfirmationModalComponent } from '../../dialogs/link-confirmation-modal/link-confirmation-modal.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'mh-core-lib-qr-download-dropdown',
    templateUrl: './qr-download-dropdown.component.html',
    styleUrls: ['./qr-download-dropdown.component.scss'],
    standalone: false
})
export class CoreLibQrDownloadDropdownComponent {
  @Input()
  originsUrls: { name: string; url: string; active: boolean }[] = [];

  @Input()
  show = true;

  @Input()
  productName = '';

  @Input()
  customerName = '';

  @Output()
  qrDownloaded = new EventEmitter<{ url: string; originName: string }>();

  @ViewChild('divDownloadQr', { static: false }) divDownloadQr: ElementRef;

  isOpen = false;

  constructor(private renderer: Renderer2, private modalService: ModalService) {}

  handleDownloadQR(url: string, originName: string) {
    this.closeDropdown();

    const config = {
      data: {
        linkName: originName,
        url: url,
        modalType: 'qr',
      },
    };

    const classes = ['overlay-panel', 'fit-height-content'];

    const confirmDialog = this.modalService.open(CoreLibLinkConfirmationModalComponent, config, classes);

    confirmDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result === 'OPEN') {
          this.downloadQRCode(url, originName);
        }

        if (result === 'CANCEL') {
          window.open(url + '&demo=true', '_blank');
        }
      });
  }

  private downloadQRCode(url: string, originName: string) {
    QRCode.toDataURL(url, { width: 500, rendererOpts: { quality: 1 }, scale: 5 }, (error, qrUrl) => {
      if (error) {
        console.error('Error generating QR code:', error);
        return;
      }

      const downloadLink = this.renderer.createElement('a');
      this.renderer.appendChild(this.divDownloadQr.nativeElement, downloadLink);
      const fileName = `${this.productName}_QR_${originName}_${this.customerName}.png`;
      downloadLink.href = qrUrl;
      downloadLink.download = fileName;
      downloadLink.click();
      this.renderer.removeChild(this.divDownloadQr.nativeElement, downloadLink);

      this.qrDownloaded.emit({ url, originName });
    });
  }

  toggleDropdown() {
    if (this.isBlocked) return;

    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  get activeOriginsUrls() {
    return this.originsUrls?.filter((item) => item.active) || [];
  }

  get hasOriginsUrls() {
    return this.activeOriginsUrls.length > 0;
  }

  get hasAnyOrigins() {
    return (this.originsUrls?.length || 0) > 0;
  }

  get isBlocked() {
    return !this.hasOriginsUrls;
  }

  get tooltipKey() {
    return this.isBlocked ? 'header.tooltips.origins_blocked' : 'header.tooltips.download_qr';
  }

  trackByUrl(index: number, item: { name: string; url: string; active: boolean }): string {
    return item.url;
  }
}
